import { render } from "./SurveyCompleted.vue?vue&type=template&id=78160cb9"
import script from "./SurveyCompleted.vue?vue&type=script&lang=js"
export * from "./SurveyCompleted.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])